import React, { useState, useEffect } from 'react';
import { Direction, Margin, Text, TextSmall, IconCardCredit, Column, TextCaption } from '@scotia/canvas-react';
import styles from '../Account/AccountContent.scss';
import { ThreeColumnProductsLayout } from '../ThreeColumnProductsLayout';
import { DataProducts } from '../DataProducts';
import { DataBalance } from '../DataBalance';
import { numberFormatter } from '../../Amounts.Converter';
import { SummaryContextMenu } from '../SummaryContextMenu';
import { getSession } from '../Account/utils';
import MercuryComponent from '../Mercury/MercuryComponent';

const CONTENT_CARD_INFO = 'account-content-card-info';
const FONT_PRODUCTS = 'font-color-product';

const CardContent = props => {
  const [mercuryApiUrl, setMercuryApi] = useState(undefined);
  const [mercuryRenderersUrl, setMercuryRenderersUrl] = useState(undefined);
  const [mercuryEnabled, setMercuryEnabled] = useState(undefined);

  useEffect(() => {
    getSession(setMercuryEnabled, setMercuryApi, setMercuryRenderersUrl);
  }, []);

  return (
    <Direction className={styles['account-content-container']}>
      {props.list.credit_cards !== undefined && (
        <div className={styles[CONTENT_CARD_INFO]}>
          {props.list.credit_cards.map((account, i) => (
            <>
              <ItemsCard account={account} />
              {i == 0 && mercuryApiUrl && mercuryRenderersUrl && (
                <Margin side={'top'} xs={24} sm={24} md={24} lg={24}>
                  <MercuryComponent apiUrl={mercuryApiUrl} renderersUrl={mercuryRenderersUrl} interactionEnabled={mercuryEnabled} idGroup="cards_section_sweb" idZone="cards_section_sweb_1" />
                </Margin>
              )}
            </>
          ))}
        </div>
      )}
    </Direction>
  );
};

export default CardContent;

const ItemsCard = account => (
  <Margin md={24} xs={6} sm={12} lg={24} side={'top'} className={styles['account-content-card-info']}>
    <ThreeColumnProductsLayout
      renderCol1={() => (
        <div style={{ padding: 0 }}>
          <Direction type="row" className="hide--lg hide--md">
            <Column xs={6} sm={7}>
              <DataProducts
                title={
                  <TextSmall className={styles[FONT_PRODUCTS]}>
                    {account.account.product_information.product_name}
                  </TextSmall>
                }
                text={
                  <TextSmall className={`${styles[FONT_PRODUCTS]} text--medium`}>{`$${numberFormatter(
                    account.account.national_balance.available_credit.amount
                  )}`}</TextSmall>
                }
                badge={
                  <TextSmall className={`${styles[FONT_PRODUCTS]} text--medium`}>
                    {account.account.international_balance.available_credit.currency_code}
                    {` ${numberFormatter(account.account.international_balance.available_credit.amount)}`}
                  </TextSmall>
                }
              />
            </Column>
            <Column xs={5} sm={4}>
              <TextCaption className="text--light">{account.account.product_information.display_id}</TextCaption>
            </Column>
            <Column xs={1} sm={1}>
              <div
                style={{
                  display: 'flex',
                  marginRight: '-20px',
                  marginTop: '-10px',
                  paddingLeft: '4px',
                  float: 'right',
                }}
              >
                <SummaryContextMenu
                  productType={account.account.product_information.product_type}
                  account={account.account.product_information.display_id}
                  productName={account.account.product_information.product_name}
                />
              </div>
            </Column>
          </Direction>
          <div className="hide--xs hide--sm">
            <DataProducts
              title={
                <div>
                  <div style={{ display: 'inline-block' }}>
                    <Text className={`${styles[FONT_PRODUCTS]} text--roman`}>
                      {account.account.product_information.product_name}
                    </Text>
                  </div>
                </div>
              }
              text={<TextSmall>{account.account.product_information.display_id}</TextSmall>}
              icon={<IconCardCredit style={{ position: 'relative', bottom: '6px' }} size={36} />}
            />
          </div>
        </div>
      )}
      renderCol2={() => (
        <div className="hide--xs hide--sm">
          <DataBalance
            title={<TextSmall>Cupo disponible</TextSmall>}
            text={
              <Text className={`${styles[FONT_PRODUCTS]} text--medium`}>
                {`$${numberFormatter(account.account.national_balance.available_credit.amount)}`}
              </Text>
            }
          />
        </div>
      )}
      renderCol3={() => (
        <div className="hide--xs hide--sm">
          <DataBalance
            title={
              <div>
                <div style={{ display: 'inline-block' }}>
                  <TextSmall>Cupo disponible</TextSmall>
                </div>
                <div
                  style={{
                    display: 'flex',
                    marginRight: '-30px',
                    marginTop: '-10px',
                    paddingLeft: '4px',
                    float: 'right',
                  }}
                >
                  <SummaryContextMenu
                    productType={account.account.product_information.product_type}
                    account={account.account.product_information.display_id}
                    productName={account.account.product_information.product_name}
                  />
                </div>
              </div>
            }
            text={
              <Text className={`${styles[FONT_PRODUCTS]} text--medium`}>
                {account.account.international_balance.available_credit.currency_code}
                {` ${numberFormatter(account.account.international_balance.available_credit.amount)}`}
              </Text>
            }
          />
        </div>
      )}
      column1={4}
      column2={4}
      column3={4}
    />
  </Margin>
);
